import type { R3InputNumberClass } from "~/classes/base/R3InputBase.classes";



export class TaraTabClass {

	visible = ref<boolean>(true);
	inputTaraPalete = autoRef<R3InputNumberClass>(null);
	inputTaraCaixa = autoRef<R3InputNumberClass>(null);
	inputTaraUnidade = autoRef<R3InputNumberClass>(null);
}